import React from "react";

const InputField = ({
  disabled,
  gradient,
  value,
  type,
  name,
  placeholder,
  className,
  defaultValue,
  label,
  numberLabel,
  subLabel,
  onBlur,
  onWheel,
  onFocus,
  autoComplete,
  onChange,
  onKeyDown,
}) => {
  const defaultClass = gradient
    ? "w-full rounded-full border pl-12 min-h-[55px] bg-white' pr-4 border-[#F0CA18] focus:outline-[#F0CA18] placeholder:text-[12px]"
    : "w-full rounded-lg border pl-4 min-h-[55px] bg-white' pr-4 border-[#CCC] focus:outline-[#CCC] placeholder:text-[12px]";

  return (
    <div className="w-full flex items-start gap-3">
      {numberLabel && (
        <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
          {numberLabel}
        </div>
      )}
      <div className="w-full flex flex-col gap-2">
        {label && <label className="text-[14px]">{label}</label>}
        {subLabel && (
          <label className="text-[14px] text-[#7A7A7A]">{subLabel}</label>
        )}
        <input
          onChange={onChange}
          onBlur={onBlur}
          onWheel={onWheel}
          onFocus={onFocus}
          autoComplete={autoComplete}
          disabled={disabled}
          className={`${defaultClass} ${className}`}
          defaultValue={defaultValue}
          type={type}
          value={value}
          name={name}
          placeholder={placeholder}
          onKeyDown={onKeyDown}
        />
      </div>
    </div>
  );
};

export default InputField;
